import { useMutation } from 'react-query'

import { applyVatSuggestionChanges } from '../query-api'

interface UseApplyVatSuggestionsProps {
  onError?: () => void
  onSuccess: () => void
}

export const useApplyVatSuggestions = ({ onSuccess, onError }: UseApplyVatSuggestionsProps) => {
  const {
    mutate: applyVatSuggestions,
    mutateAsync: createAsync,
    isLoading: isProcessing,
    ...rest
  } = useMutation(applyVatSuggestionChanges, {
    onSuccess,
    onError,
  })

  return { applyVatSuggestions, createAsync, isProcessing, ...rest }
}
